import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getUser } from '../../selectors/user';

export const useIsRealtor = (): boolean => {
  const user = useSelector(getUser);

  return useMemo(() => Boolean(user.isAuthenticated && user.isAgent && !user.isBuilder), [user]);
};
